import ContactDialog from "@/src/free-assessment/result/_components/ContactDialog";
import RequestPaidAssessmentDialog from "@/src/free-assessment/result/_components/RequestPaidAssessmentDialog";
import { format } from "date-fns";
import { useTranslation } from "react-i18next";

function Heading() {
  const { t } = useTranslation();
  const today = format(new Date(), t("date-format"));

  return (
    <div className="flex flex-col justify-between gap-4 border-b pb-5 lg:flex-row">
      <div className="flex flex-col gap-2">
        <div className="text-lg font-medium">{t("assessment-full-title")}</div>
        <div className="text-2xl font-bold">{t("free-assessment")}</div>
        <div className="flex gap-5">
          <span>
            {t("carry-on-date")}: {today}
          </span>
        </div>
      </div>
      <div className="flex gap-2 items-center">
        {/* <Button onClick={() => navigate("/free-assessment/certificate")}>
          {t("download-certificate")}
        </Button> */}
        <RequestPaidAssessmentDialog />
        {/* <ContactDialog /> */}
      </div>
    </div>
  );
}

export default Heading;
